import React from 'react'
import { change as changeFieldValue, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import cadastrarUsuario from '../../../actions/usuario/cadastrarUsuarioPlataforma'
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import {
    renderFieldCpf,
    renderFieldEmail,
    renderFieldSelect,
    renderFieldTelefone,
    required,
    requiredCPF,
} from '../../../util/inputs';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import { showSuccessMsg } from '../../../util/messagesUtil';
import ptBR from 'date-fns/locale/pt-BR';
import { registerLocale, setDefaultLocale } from 'react-datepicker';

registerLocale('pt-BR', ptBR);
setDefaultLocale('pt-BR');


export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                id={input.name}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class ModalCadastrarUsuarioPlataforma extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.submit = this.submit.bind(this);
        this.selecionarPlataforma = this.selecionarPlataforma.bind(this);

        this.state = {
            plataformaClicada: null,
            tipoCampoChavePixSelecionado: null,
            tipoChavePixSelecionado: null
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cidade !== this.props.cidade) {
            this.props.changeFieldValue('formularioCadastroUsuario',
                'localidade', this.props.cidade);
        }
    }

    limparCampos() {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'logradouro', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'complemento', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'bairro', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'localidade', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'uf', '');
        this.props.changeFieldValue('formularioCadastroUsuario',
            'numero', '');
    }

    limparCamposPlataforma() {
        this.setState({ plataformaClicada: null });
        this.setState({ tipoCampoChavePixSelecionado: null });
    }

    selecionarPlataforma(elemento) {
        this.setState({ plataformaClicada: elemento.value });
    }

    onChangeTipoChavePix(elemento) {
        this.props.changeFieldValue('formularioCadastroUsuario',
            'chavePix', '');
        this.setState({ tipoCampoChavePixSelecionado: elemento.value })
        this.setState({ tipoChavePixSelecionado: elemento });
    }

    montarParametroUsuario(values) {
        return {
            id: this.props.usuarioSelecionado.id,
            nome: values.nome,
            email: values.email,
            roles: values.perfil ? [values.perfil.value] : [],
            telefone: values.telefoneUsuario,
            cpf: values.cpf,
            plataforma: values.plataforma.value,
        };
    }

    submit(values) {
        this.props.cadastrarUsuario(this.montarParametroUsuario(values))
            .then(() => {
                showSuccessMsg('Usuario cadastrado com sucesso');
                this.fechar();
                if (document.getElementById(this.props.usuarioSelecionado.id)) {
                    document.getElementById(this.props.usuarioSelecionado.id).checked = values.perfil;
                }
                this.fecharModal();
            });
    }

    fecharModal() {
        $('#modalCadastrarUsuarioPlataforma')
            .modal('hide');
        $('#modalCadastrarUsuarioPlataforma')
            .hide();
        $('.modalCadastrarUsuarioPlataforma')
            .hide();
        this.limparCamposPlataforma();
    }

    fechar() {
        this.props.reset('formularioCadastroUsuario');
        this.props.buscarUsuarios();
        this.limparCamposPlataforma();
    }

    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;
        return (
            <div className="modal fade show" id='modalCadastrarUsuarioPlataforma' role='dialog'
                aria-labelledby='modalCadastrarUsuarioPlataforma' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content" style={{borderTop:'4px solid #FF6A00', borderRadius:12}}>
                        <div className="modal-header" style={{borderBottom:'1px solid #f0f0f0'}}>
                            <h5 style={{display:'flex', alignItems:'center', gap:8, margin:0, fontSize:16, fontWeight:700}}>
                                <i className="material-icons" style={{color:'#FF6A00', fontSize:20}}>devices</i>
                                Usuário Plataforma
                            </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fechar()}>
                                <i className="material-icons">close</i>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row mt-2">
                                    <div className="col-12 col-sm-12 col-md-9">
                                        <Field name='plataforma'
                                            options={this.props.plataformas.filter(e => e !== 'Todas').map(elemento => ({
                                                descricao: elemento,
                                                nome: elemento
                                            }))}
                                            value={this.state.plataformaSelecionada}
                                            onChange={this.selecionarPlataforma}
                                            component={renderFieldSelect}
                                            label='Plataforma'
                                            placeholder='Selecione...'
                                            disabled={this.props.usuarioSelecionado.id ? true : false}
                                        />
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                                            validate={[required]}
                                            css="form-control" readOnly={false} />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="cpf" type="text" component={renderFieldCpf} label="CPF:"
                                            validate={[requiredCPF]}
                                            css="form-control" />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="col-12 col-sm-5 col-md-5">
                                        <Field name="nome" type="text" validate={[required]} component={renderField}
                                            label="Nome Completo:"
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-3 col-md-3">
                                        <Field name="telefoneUsuario" type="text"
                                            component={renderFieldTelefone}
                                            css="form-control" label="Telefone" />
                                    </div>
                                </div>
                                <div className="form-row mt-2">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name='perfil'
                                            options={[
                                                {
                                                    descricao: 'Cliente',
                                                    nome: 'ROLE_CLIENTE'
                                                },
                                            ]}
                                            isClearable={true}
                                            component={renderFieldSelect}
                                            label='Perfil'
                                            placeholder='Selecione...'
                                        />
                                    </div>
                                </div>
                                <div className="form-group area-codigo">
                                    <Field name="idUsuario" type="hidden" component={renderField}
                                        css="form-control col-md-12" />
                                </div>
                                <div className="modal-footer">
                                    <button id="btn-salvar" type="submit" disabled={invalid || submitting}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {

    return {
        plataformas: state.plataformas,
        usuarioSelecionado: state.usuarioSelecionado,
        initialValues: {
            email: state.usuarioSelecionado.email,
            nome: state.usuarioSelecionado.nome,
            cpf: state.usuarioSelecionado.cpfCnpj,
            telefoneUsuario: state.usuarioSelecionado.telefone,
            plataforma: {
                label: state.usuarioSelecionado.plataforma,
                value: state.usuarioSelecionado.plataforma
            },
            perfil: state.usuarioSelecionado.rolesName && state.usuarioSelecionado.rolesName.length ? {
                label: state.usuarioSelecionado.rolesName[0].descricao,
                value: state.usuarioSelecionado.rolesName[0].valor
            } : null,
        },
        pessoa: state.usuarioSelecionado.pessoa,
        plataformaSelecionada: state.usuarioSelecionado.plataforma,
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuario,
        selecionarPerfis,
        buscarUsuarioPorEmail,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroUsuario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(ModalCadastrarUsuarioPlataforma));
